import { render, staticRenderFns } from "./facturen.vue?vue&type=template&id=1765f81f&"
import script from "./facturen.vue?vue&type=script&lang=js&"
export * from "./facturen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports